import React, { useState, useEffect } from 'react';

export default function Footer() {
  const [contactInfo, setContactInfo] = useState({
    address: "Khulna, Bangladesh",
    phone: "+012 345 67890",
    email: "info@example.com"
  });
  const [socialLinks, setSocialLinks] = useState([]);
  const [loadingContact, setLoadingContact] = useState(true);
  const [loadingSocialLinks, setLoadingSocialLinks] = useState(false);

  useEffect(() => {
    fetchContactInfo();
    fetchSocialLinks();
  }, []);

  const fetchContactInfo = async () => {
    try {
      setLoadingContact(true);
      const response = await fetch('https://travel-agency-server-lilac.vercel.app/api/contact/contact-info');

      if (!response.ok) {
        throw new Error('Failed to fetch contact info');
      }

      const data = await response.json();

      if (data.success && data.contactInfo) {
        setContactInfo(data.contactInfo);
      }
    } catch (error) {
      console.error('Failed to fetch contact info:', error);
      // Keep default values if API fails
    } finally {
      setLoadingContact(false);
    }
  };

  const fetchSocialLinks = async () => {
    try {
      setLoadingSocialLinks(true);
      const response = await fetch('https://travel-agency-server-lilac.vercel.app/api/social-links');

      if (!response.ok) {
        throw new Error('Failed to fetch social links');
      }

      const data = await response.json();

      if (data.success && data.socialLinks) {
        // Filter out duplicates by platform (keep only first occurrence)
        const uniqueLinks = [];
        const platformSet = new Set();

        data.socialLinks.forEach(link => {
          if (!platformSet.has(link.platform)) {
            platformSet.add(link.platform);
            uniqueLinks.push(link);
          }
        });

        setSocialLinks(uniqueLinks);
      }
    } catch (error) {
      console.error('Failed to fetch social links:', error);
      // Keep empty array if API fails
      setSocialLinks([]);
    } finally {
      setLoadingSocialLinks(false);
    }
  };

  const getPlatformIcon = (platform, customIcon = '') => {
    if (customIcon) return customIcon;

    const platformIcons = {
      'facebook': 'fab fa-facebook-f',
      'twitter': 'fab fa-twitter',
      'instagram': 'fab fa-instagram',
      'linkedin': 'fab fa-linkedin-in',
      'youtube': 'fab fa-youtube',
      'tiktok': 'fab fa-tiktok',
      'pinterest': 'fab fa-pinterest',
      'whatsapp': 'fab fa-whatsapp',
      'snapchat': 'fab fa-snapchat',
      'telegram': 'fab fa-telegram'
    };
    return platformIcons[platform] || 'fas fa-share-alt';
  };

  const getPlatformDisplayName = (platform) => {
    const platformNames = {
      'facebook': 'Facebook',
      'twitter': 'Twitter / X',
      'instagram': 'Instagram',
      'linkedin': 'LinkedIn',
      'youtube': 'YouTube',
      'tiktok': 'TikTok',
      'pinterest': 'Pinterest',
      'whatsapp': 'WhatsApp',
      'snapchat': 'Snapchat',
      'telegram': 'Telegram'
    };
    return platformNames[platform] || platform.charAt(0).toUpperCase() + platform.slice(1);
  };

  if (loadingContact) {
    return (
      <div className="container-fluid bg-dark text-light footer pt-5 mt-5">
        <div className="container py-5">
          <div className="text-center">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      {/* Footer Start */}
      <div
        className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <div className="row g-5">
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Company</h4>
              <a className="btn btn-link" href="/about">
                About Us
              </a>
              <a className="btn btn-link" href="/contact">
                Contact Us
              </a>
              <a className="btn btn-link" href="/privacy">
                Privacy Policy
              </a>
              <a className="btn btn-link" href="/terms">
                Terms &amp; Condition
              </a>
              <a className="btn btn-link" href="/faq">
                FAQs &amp; Help
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Contact</h4>
              <p className="mb-2">
                <i className="fa fa-map-marker-alt me-3" />
                {contactInfo.address}
              </p>
              <p className="mb-2">
                <i className="fa fa-phone-alt me-3" />
                {contactInfo.phone}
              </p>
              <p className="mb-2">
                <i className="fa fa-envelope me-3" />
                {contactInfo.email}
              </p>
              <div className="d-flex pt-2">
                {loadingSocialLinks ? (
                  <div className="d-flex align-items-center">
                    <div className="spinner-border spinner-border-sm text-light me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <small className="text-light">Loading social links...</small>
                  </div>
                ) : (
                  socialLinks
                    .filter(link => link.isActive)
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((link) => (
                      <a
                        key={link._id || link.platform}
                        className="btn btn-outline-light btn-social me-2"
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={getPlatformDisplayName(link.platform)}
                      >
                        <i className={getPlatformIcon(link.platform, link.customIcon)}></i>
                      </a>
                    ))
                )}
                {!loadingSocialLinks && socialLinks.filter(link => link.isActive).length === 0 && (
                  <small className="text-light">
                    <i className="fas fa-share-alt me-1"></i>
                    Follow Us
                  </small>
                )}
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Gallery</h4>
              <div className="row g-2 pt-2">
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-1.jpg"
                    alt="Travel Package 1"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-2.jpg"
                    alt="Travel Package 2"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-3.jpg"
                    alt="Travel Package 3"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-2.jpg"
                    alt="Travel Package 4"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-3.jpg"
                    alt="Travel Package 5"
                  />
                </div>
                <div className="col-4">
                  <img
                    className="img-fluid bg-light p-1"
                    src="assets/img/package-1.jpg"
                    alt="Travel Package 6"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <h4 className="text-white mb-3">Newsletter</h4>
              <p>Stay updated with our latest travel offers and news.</p>
              <div
                className="position-relative mx-auto"
                style={{ maxWidth: 400 }}
              >
                <input
                  className="form-control border-primary w-100 py-3 ps-4 pe-5"
                  type="text"
                  placeholder="Your email"
                />
                <button
                  type="button"
                  className="btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2"
                >
                  SignUp
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                ©{" "}
                <a className="border-bottom" href="/">
                  Asian Travel Agency
                </a>
                , All Right Reserved.
              </div>
              <div className="col-md-6 text-center text-md-end">
                <div className="footer-menu">
                  <a href="/">Home</a>
                  <a href="/privacy">Cookies</a>
                  <a href="/contact">Help</a>
                  <a href="/faq">FQAs</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Back to Top Button */}
      <a
        href="#"
        className="btn btn-lg btn-primary btn-lg-square back-to-top"
      >
        <i className="bi bi-arrow-up"></i>
      </a>
    </div>
  );
}